/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  cta: {
    connexion: 'Login',
    login: 'Log in',
    logout: 'Log out',
    send: 'Send',
    donate: 'Donate',
    description: 'Description',
    history: 'History',
    goto_forgot_password: 'Forgot password?',
    goto_login: 'Return to the login screen',
    start: 'Start the session',
    settings: 'Configure the effect',
    start_exercise: 'Start',
    restart: 'Restart',
    restart_exercise: 'Continue the exercise',
    pause_exercise: 'Pause',
    skip_exercise: 'Skip',
    next_exercise: 'Next',
    authorize: 'Allow',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    modify: 'Edit',
    back: 'Return',
    confirm: 'Ok',
    support: 'Help',
    verify: 'Verify',
    mfa_resend: 'Resend the code',
  },
};
